<template>
    <div class="company-Main" style="background: #eff2f5;">
        <p class="current">当前位置：<span>商品详情</span></p>
        <div class="company-info">
            <div class="company-top"> 
                <div class="box">
                    <el-carousel :interval="4000" width="100%" height="600px" autoplay>
                        <el-carousel-item v-for="item in companyInfo.file_items" :key="item.id">
                        
                            <div class="companyImg">
                                <img :src="item.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div  class="box right_info" >
                    <div>
                        <p>{{ companyInfo.name }}</p>
                    </div>
                    <div class="price-box" v-if="IsToken">
                        <p class="companyName priceP">￥ 
                            <span v-if="minPrice != maxPrice">{{ minPrice }}~{{ maxPrice }}</span>
                            <span v-if="minPrice == '' && maxPrice == ''">{{ companyInfo.price }}</span>
                            <span v-if="minPrice == maxPrice">{{ minPrice }}</span>
                            <span style="color: #333; font-size: 14px;">/{{ companyInfo.unit }}</span>

                            <span style="margin-left: 20px;color: #666666; font-size: 14px;">(含税13%)</span>
                        </p>
                    </div>
                    <div class="backg_box">
                        <div class="price-info" v-if="companyInfo.pcode != '' || companyInfo.pcode != null">
                            <!-- <P>含税：</P>
                            <p>会员优惠：</p> -->
                            <p>编码型号：{{ companyInfo.pcode }}</p>
                        </div>
                        <div class="titleBox" >
                            <span class="divP">规格</span>
                            <span class="titles" style="cursor: pointer" @click="drawerIs(1)">共<span style="color: #10aeff;">{{ total }}</span>种</span>
                        </div>
                        <div class="titleBox">
                            <span class="divP">配送至</span>
                            <span class="titles">{{ city }}</span>
                        </div>
                        
                        <div class="titleDiv">
                            <p class="divP">服务</p>
                            <div>
                                <p>
                                    <img src="../../assets/icon_1.png" alt="">
                                    <span>{{ cinfigInfo.product_service }}</span>
                                </p>
                               
                            </div>
                        </div>
                        <!-- <p class="elTag">
                            <el-tag>订货</el-tag><span>37个工作日发货，预计10月08号送达</span>
                        </p>
                        <p class="elTag">
                            <el-tag>运费</el-tag><span>满300包邮</span>
                        </p> -->
                    </div>    
                    
                    <div style="padding: 10px 10px;margin-bottom: 60px;" v-if="companyInfo.param_item != ''">
                        <div class="titleDiv">
                            <p class="divP">参数</p>
                            <!-- <div>
                                <p>
                                    帮装规格：1双/盒
                                </p>
                                <p>
                                    10/箱
                                </p>
                            </div> -->
                        </div>
                        
                        <div class="canshu" v-if="companyInfo.param_item != ''">
                            <div class="canshuTitle" >
                                <p v-for="item,index in companyInfo.param_item" :key="index">{{ item.name }}</p>
                                
                               
                            </div>
                            <div class="canshuContext">
                                <p v-for="item,index in companyInfo.param_item" :key="index">{{ item.value }}</p>
                               
                            </div>
                        </div>
                        
                    </div>
                  
                    
                    <div class="button-flex">
                        <div class="iconBox">
                            <i class="el-icon-service" @click="HandleSession"></i>
                            <i class="el-icon-shopping-cart-full" @click="HandleCart"></i>
                        </div>
                        <div class="buttonBox">
                            <el-button type="primary" plain @click="drawerIs(1)">加入购物车</el-button>
                            <el-button type="primary"  @click="drawerIs(2)">立即购买</el-button>
                        </div>
                    </div>
                </div>
            </div>
           
            
            <el-drawer
                title="加入购物车"
                :visible.sync="drawer"
                direction="btt"
                size="40%"
                :with-header="false">
                <div class="drwer">
                    <p class="drwerTitle">
                        {{ butStatus == 1 ? '加入购物车': butStatus == 2 ? '购买商品' : '' }}
                    </p>
                    <div class="enable_drawer_info"> 
                        <div class="drawer_left">                 
                            <div style="margin-bottom: 20px;padding-bottom: 5px;" v-if="companyInfo.att != ''">
                                <p v-if="companyInfo.att[0].att_item != ''">{{ companyInfo.att[0].name }}</p>
                                <div>
                                    <el-tag :effect="item.name == plainName1?'dark':'plain'" v-for="item in companyInfo.att[0].att_item" :key="item.id"  @click="handleDark1(item.id,item.name)">{{ item.name }}</el-tag>
                                </div>
                            </div>
                            <div v-if="companyInfo.att.length == 2">
                                <p>{{ companyInfo.att[1].name }}</p>
                                <div>
                                    <el-tag :effect="item.name == plainName2?'dark':'plain'"  v-for="item in companyInfo.att[1].att_item" :key="item.id" @click="handleDark2(item.id,item.name)">{{ item.name }}</el-tag>
                                </div>
                            </div>
                            <div class="enable_num">
                                <p>购买数量</p>
                                <el-input-number v-if="butStatus == 2" v-model="num" :min="companyInfo.min_amount"  size="mini"></el-input-number>
                                <el-input-number v-if="butStatus == 1" v-model="num" :min="1"  size="mini"></el-input-number>
                            
                            </div>

                            <el-button type="primary"  @click="buygoods" v-show="butStatus == 1" >加入购物车</el-button>
                            <el-button type="primary"  @click="checkoutQuick" v-show="butStatus == 2"  :disabled="stock == 0?true:false">确认购买</el-button>
                        </div>
                        <div class="drawer_image">
                            <div v-if="guigeImg != ''">
                                <img :src="guigeImg" style="width: 150px;height: 150px; object-fit: cover;border: 1px solid #f2f2f2;" alt="">
                            </div>
                            <div v-if="guigeImg == ''">
                                <img :src="companyInfo.file_items[0].FileUrl" style="object-fit: cover;border: 1px solid #f2f2f2;height: 150px;width: 150px;" alt="">
                            </div>
                            <div>
                                <p>￥ 
                                    <span v-if="companyInfo.att_item_price.length != 0">{{ numbersPrice }}</span>
                                    <span v-if="numbersPrice == ''">{{ companyInfo.price }}</span>
                                    <span v-if="companyInfo.att_item_price.length == 0">{{ companyInfo.price }}</span>
                                    <!-- <span v-if="numbersPrice == ''">{{ companyInfo.price }}</span> -->
                                </p>
                                <p>最低起购{{ companyInfo.min_amount }}{{ companyInfo.unit }}</p>
                                <p>库存{{ stock }}</p>
                                <p v-if="plainName1 != '' || plainName2 != ''">已选 <span >{{ plainName1 }} <span v-if="plainName2!=''">,</span> {{ plainName2 }}</span> </p>
                            </div>
                        </div>
                    </div>
                    

                    <el-drawer
                        :append-to-body="true"
                        direction="btt"
                        :visible.sync="innerDrawer">
                        <div class="drwer">
                            <div class="checkoutQuick-box">
                                <div class="Item-left" v-show="orderAdd != ''">
                                    <div>
                                        <img :src="orderAdd.firstFile.FileUrl" style="width: 90px;height: 62px;object-fit: cover;" alt="">
                                    </div>
                                    <div class="left-font">
                                        <p>{{orderAdd.product_name}}</p>
                                        <span>￥{{orderAdd.price}}</span>
                                        <p style="font-size: 16px;color: #666666">已选规格：{{ plainName1 }},{{ plainName2 }}</p>
                                    </div>
                                </div>
                                <div class="Item-right">
                                    <el-input-number v-model="orderAdd.amount" :step="1" :min="companyInfo.min_amount"  @change="getNum"></el-input-number>
                                </div>
                            </div>

                            <div class="priceBox" >
                                <p style="margin-top: 20px;">商品总额：<span style="font-size: 18px;">￥</span><span>{{ priceNum }}</span></p>
                                <el-button type="primary" @click="HnadleQuick">去结算</el-button>
                            </div>
                        </div>
                        
                    </el-drawer>
                </div>
            </el-drawer>



        </div>

        <div style="margin-top: 10px;background-color: #ffffff;padding: 10px 10px;">
            <div class="remark_box" v-if="remarkList != ''" >
                <p class="remarkTitle">评论</p>
                <div v-if="remarkList != ''" >
                    <div  v-for="item in remarkList" :key="item.id" class="remark_for">
                        <div  >
                            <div class="remark-box">
                                <p>{{ item.user_mobile.slice(0,3) }}********</p>
                                <p>{{ item.create_time }}</p>
                            </div>
                            <p style="text-align: left;color: #666666;">
                                {{ item.content }}
                            </p>
                        </div>
                        <div  class="fileImage">

                            <div v-for="files in item.file_items" :key="files.id">
                                <img :src="files.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="more_box">
                        <p @click="handleMore('1')" v-show="IsRemarkMore">更多评论</p>
                        <p @click="handleMore('2')" v-show="!IsRemarkMore">收起评论</p>
                    </div>
                    
                    <!-- <el-carousel height="50px" direction="vertical" autoplay :interval="4000" >
                        <el-carousel-item v-for="item in remarkList" :key="item.id">
                            <div class="remark-box">
                                <p>{{ item.user_mobile.slice(0,3) }}********</p>
                                <p>{{ item.create_time }}</p>
                            </div>
                            <p style="text-align: left;color: #666666;">
                                {{ item.content }}
                            </p>
                        </el-carousel-item>
                    </el-carousel> -->
                 </div>
            </div> 
            <div class="enableInfo">
                <p class="remarkTitle">商品介绍</p>
                <div v-html="companyInfo.intro" class="introinfo"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTimeDate } from '@/js/getTime';

// import axios from 'axios';
export default({
    data(){
        return {
            companyInfo: [],
            activeNames: ['1','4',],
            names: '',
            ids: '',
            companyproduct: [],
            drawer: false,
            innerDrawer: false,
            num: '',
            butStatus: '',
            remarkList: [],
            orderAdd: { firstFile:{FileUrl: ''}},
            priceNum: '',
            widthNew: false,
            IsToken:false,
            plainId1: '',
            plainId2: '',
            plainName1: '',
            plainName2: '',
            guigeImg: '',
            cinfigInfo: '',
            maxPrice: '',
            minPrice: '',
            numbersPrice: '',
            city:'',
            remarkMore: [],
            IsRemarkMore: true,
            stock: 0,
            total: 0
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        HandleCart(){
            // if(!localStorage.getItem('token')){
            //     this.$notify({
            //     title: '提示',
            //     message: '未登录或超时，请重新登陆',
            //     type: 'error'
            //     })
            //     this.$router.push('/login')
            // }else{
                const {href} = this.$router.resolve({
                    path: '/cart',
                })
                window.open(href, '_blank')
            // }
        },
        drawerIs(val){
            if(!localStorage.getItem('token')){
                this.$notify({
                title: '提示',
                message: '未登录或超时，请重新登陆',
                type: 'error'
                })
                this.$router.push('/login')
            }else{
                this.drawer = true
                this.butStatus = val
            }
            
        },  
        handleDark1(id,name){
            this.plainId1 = id
            this.plainName1 = name
            this.getImg()
        },
        handleDark2(id,name){
            this.plainId2 = id
            this.plainName2 = name
            this.getImg()
        },
        getImg(){
           
            if(this.companyInfo.att.length > 1){
                this.names = '[' + this.plainName1 + ',' + this.plainName2 + ']'
                this.ids = '[' + this.plainId1 + ',' + this.plainId2 + ']'
            }else {
                this.names = '[' + this.plainName1 + ']'
                this.ids = '[' + this.plainId1 + ']'
            }
            console.log("oooooooooopppppppppp7777777777777");
            console.log( this.companyInfo.att_item_price.length);
            const numbers = []
            let num = this.companyInfo.att_item_price.length
            if (num == 0) {
                
                this.numbersPrice = this.companyInfo.price
                this.stock = this.companyInfo.stock

            }else if(num == 1){
                this.maxPrice = this.companyInfo.att_item_price[0].price
                this.minPrice = this.companyInfo.att_item_price[0].price
                this.stock = this.companyInfo.att_item_price[0].stock
                this.numbersPrice = this.companyInfo.att_item_price[0].price
            }else if(num > 1){
                console.log("oooooooooopppppppppp");
                console.log(this.names);
                this.companyInfo.att_item_price.forEach(item => {
                    if(this.names == item.name){
                        this.guigeImg = item.img_url

                        this.numbersPrice = item.price
                        this.stock = item.stock
                    }
                    numbers.push(item.price)
                });

                this.maxPrice = Math.max(...numbers);
                this.minPrice = Math.min(...numbers);
            }
           
           
           
        },
        buygoods(){
           
                console.log( this.companyInfo);
                this.ids =  '[' + this.plainId1 + ',' + this.plainId2 + ']'
                this.names = '[' + this.plainName1 + ',' + this.plainName2 + ']'

                let nameList = this.plainName1 + ',' + this.plainName2
                let idList = this.plainId1 + ',' + this.plainId2

                let data = {
                    amount: this.num,
                    atts_items_ids: idList,
                    atts_items_names: nameList,
                    buycate: 'cart',
                    product_id: this.companyInfo.id,
                }

                this.$store.dispatch('personal/buygoods',data)
                    .then(res => {
                        if(res.ok){
                            this.$notify({
                                title: '提示',
                                message: '加入购物车成功',
                                type: 'success'
                            })
                            this.drawer = false
                        }else if(res.code == -1 && res.msg == '未登录或超时'){
                            this.$notify({
                                title: '提示',
                                message: '未登录或超时，请重新登陆',
                                type: 'error'
                            })
                            this.$router.push('/login')
                        }
                    })
                
           
        },
        checkoutQuick(){
            let data = {
                amount: this.num,
                atts_items_ids: this.ids,
                atts_items_names: this.names,
                buycate: "buy",
                product_id: this.$route.query.id
            }
            this.$store.dispatch('personal/buygoods',data)
                .then(res => {
                    if(res.ok){
                       

                        let orderOn = {
                            order_no: '111111',
                            product_type: 'product',
                        }
                        this.$store.dispatch('enable/orderOn',orderOn)
                            .then(res => {
                                if(res.ok){
                                    this.innerDrawer = true
                                    this.orderAdd = res.data.items[0]
                                    this.priceNum = this.orderAdd.price * this.orderAdd.amount
                                   
                                }
                            })
                    }else if(res.data == 'notlogin' ){
                        this.$notify({
                            title: '提示',
                            message: '未登录，请先登陆',
                            type: 'error'
                        })

                        this.$router.push('/login')
                    }
                })
            // const { href } = this.$router.resolve({
            //     path: '/checkoutQuick'
            // })
            // window.open(href, '_blank')
        },

        // 评论
        HandleRemark(data){
            this.$store.dispatch('enable/listremark',data)
                .then(res => {
                    if(res.ok){
                        let list = res.data.items
                        
                        
                        list.forEach((item,index) => {
                            item.create_time = getTimeDate(item.create_time)
                            this.remarkMore.push(item)
                            if(index < 2){
                                this.remarkList.push(item)
                            }
                        });
                  
                    }
                })
        },
        handleMore(val){
            let list = []
            list = this.remarkMore

            this.remarkList = []
            if(val == 1){
                this.IsRemarkMore = false
                list.forEach((item,index) => {
                    this.remarkList.push(item)
                });  
            }else if(val == 2){
                this.IsRemarkMore = true
                list.forEach((item,index) => {
                    if(index < 2){
                        this.remarkList.push(item)
                    }
                }); 
            }
            
        },
        getNum(currentValue, oldValue){


            let data = {

                amount: currentValue,
                id: this.orderAdd.id,
                order_no: "111111",
                product_id: this.$route.query.id,
            }
            this.$store.dispatch('personal/updateSelf',data)
                .then(res => {
                    if(res.ok){
                        this.priceNum = this.orderAdd.price * currentValue
                    }
                })

            },
        HnadleQuick(){
            let listId = this.$route.query.id
           
            const { href } = this.$router.resolve({
                path: '/checkoutQuick',
                query: {
                    ids: '',
                    order: '111111'
                }
            })
            window.open(href, '_blank')
        },
        formatRichText (html, conWidth) {
            // 去掉img标签里的style、width、height属性
            let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 去掉video标签里的style、width、height属性
            newContent= html.replace(/<video[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 修改所有style里的width属性为max-width:100%
            // 去掉所有style里的font-size属性
            newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
                match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
                //match = match.replace(/font-size:[^;]+;/gi, '');
                //match = match.replace(/text-indent:[^;]+;/gi, '');
                return match;
            });
            // 去掉<br/>标签
            newContent = newContent.replace(/<br[^>]*\/>/gi, '');
            // img标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:'+ conWidth +'px;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:100%;height:auto;display:block;margin:0px auto;"');
            // video标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<video/gi, '<video style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            return newContent;
        },
        HandleSession(){
            this.$router.push({
                path: '/session',
            })
        },
        GetConfig(){
            let data = {}
            this.$store.dispatch('enable/GetConfig',data)
                .then(res => {
                    if(res.ok){
                        this.cinfigInfo = res.data
                    }
                })
        },
        
    },
    mounted(){
        // this.getLocation()
        // this.$alert(returnCitySN['cip'] + returnCitySN['cname']);
        this.city = window.returnCitySN['cname']

        if(localStorage.getItem('token')){
            this.IsToken = true
        }else{
            this.IsToken = false
        }
        this.GetConfig()
        let data = {
            id: this.$route.query.id
        }
        console.log("第一步");
        this.$store.dispatch('enable/productinfo',data)
            .then(res => {
                console.log('productinfo')
                console.log(res.data)
                if(res.ok){
                    this.companyInfo = res.data
                    this.total =  res.data.att_item_price.length
                    // this.stock = res.data.stock
                    if(this.companyInfo.min_amount != ''){
                        this.num = this.companyInfo.min_amount
                    }else{
                        this.num = 1
                    }
                    this.companyInfo.intro = this.formatRichText(this.companyInfo.intro)
                    let remarkData = {
                        xcate: this.companyInfo.product_type,
                        xid: this.$route.query.id,
                        pageSize: '2',
                    }
                    let num = this.companyInfo.att.length
                    if (num == 2) {
                        
                    }
                    if(this.companyInfo.att != ''){
                        
                        this.companyInfo.att.forEach((item,index) => {
                            if(index == 0){
                                if(item.att_item != ''){
                                    this.plainName1 = item.att_item[0].name
                                    this.plainId1 = item.att_item[0].id
                                }
                                
                            }else if(index == 1){
                                if(item.att_item != ''){
                                    this.plainName2 = item.att_item[0].name
                                    this.plainId2 = item.att_item[0].id
                                }
                               
                            }
                            
                        });
                       
                    }
                    this.getImg()
                    

                    this.HandleRemark(remarkData)
                }
            })
        
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }
    
})
</script>
<style scoped lang="scss">
@import url(../../css/info.css);


.company-info{
    width: 1180px;
    padding: 10px 10px;
    background: #fff;
    margin-top: 10px;
    .company-top{
        display: flex;
        justify-content: space-between;
    
        .box:nth-child(1){
            width: 600px;
            height: 600px;
            
        }
        .box:nth-child(2){
            width: 560px;
            padding-bottom: 20px;
            position: relative;
            .price-box{
                display: flex;
                justify-content: flex-start;
                .priceP{
                    font-size: 16px;
                    color: #ff2f4f;
                    text-align: left;
                    margin-top: 10px;
                    span{
                        font-size: 30px;
                        color: #ff2f4f;
                    }
                }
            }
            .price-info{
                font-size: 16px;
                margin-bottom: 10px;
                color: #808080;
                p{
                    margin-top: 3px;
                }
            }
            .backg_box{
                background-color: #f2f2f2;
                margin-top: 10px;
                padding: 10px 10px;
                border-radius: 10px;
            }
            .titleBox{
                margin-top: 5px;
                color: #333333;
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                .divP{
                    font-weight: 600;
                }
                .titles{
                    color: #808080;
                    margin-left: 20px;
                }
            }
            .elTag{
                margin: 5px 0px 0px 0px;
                font-size: 16px;
                color: #808080;
                span:nth-child(2){
                    margin-left: 10px;
                }
            }
            
            .titleDiv{
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                .divP{
                    font-size: 16px;
                    color: #333333;
                    font-weight: 600;
                }
                div{
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    font-size: 16px;
                    p{
                        margin-left: 15px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        color: #808080;
                        img{
                            width: 15px;height: 15px;
                            margin-right: 5px;
                        }
                    }
                }
            }
            .canshu{
                font-size: 15px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                margin-top: 10px;
                div p{
                    padding: 10px 5px;
                    height: 20px;
                    border-bottom: 1px solid #f2f2f2;
                }
                .canshuTitle{
                    width: 30%;
                    color: #808080;

                }
                .canshuContext{
                    width: 70%;
                    color: #333333;
                }
            }

            .button-flex{
                position: absolute;
                width: 98%;
                bottom: 8px;
                border-radius: 5px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: #eff2f5;
                margin-top: 30px;

                padding: 10px 5px;
                .iconBox{
                    display: flex;
                    justify-content: space-between;
                    padding: 0 5px 0 5px;
                    // margin-left: 15px;
                    cursor: pointer;
                    font-size: 30px;
                    i{
                        margin-right: 15px;
                    }
                }
                .iconBox i:hover{
                    color: #4095e5;
                }
                .buttonBox{
                    padding: 0px;margin: 0px;
                    display: flex;
                    justify-content: flex-start;
                    width: 80%;
                }
                .buttonBox .el-button--primary{
                    width: 50%;
                    
                }
            }
            
            
        }

       

    }
   
    
}
.remark_box{
    margin-top: 20px;
    max-height: 1200px;
    overflow: auto;
    .remarkTitle{
        font-size: 18px;
        color: #333333;
        font-weight: 700;
        margin-bottom: 20px;
    }
    .remark-box{
        display: flex;
        justify-content: space-between;
        // align-items: center;
        text-align: left;
        color: #666666;
        p{
            margin-bottom: 10px;
        }
        p:nth-child(1){
            color: #333333;
        }
    }

    .remark_for{
        padding: 10px 10px 20px 10px;
        margin-bottom: 10px;
        border-bottom: 0.5px solid #f2f2f2;
        font-size: 16px;
        .fileImage{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-flow: row wrap;
            div{
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                width: 160px;height: 122px;
                margin: 5px 5px;
            }
           
        }
    }
    .more_box{
        text-align: right;
        font-size: 16px;
        color: #4095e5;
        cursor: pointer;
    }
}

.enableInfo{
    margin-top: 20px;
    p{
        font-size: 18px;
        color: #333333;
        font-weight: 700;
        margin-bottom: 20px;
    }
}
.drwer{
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    padding: 15px 15px;
    .drwerTitle{
        font-size: 20px;
        margin-bottom: 20px;
    }
    .enable_drawer_info{
        display: flex;
        justify-content: flex-start;
        .drawer_left{
            margin: 0 40px 20px 0;
            min-width: 400px;
            max-width: 700px;
            .enable_num{
                margin-top: 20px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                p{
                    margin-right: 20px
                }
            }
            p{
                font-size: 14px;
                color: #333333;
                margin-bottom: 8px;
            }
            .el-tag{
                margin-right: 10px;
                margin-bottom: 10px;
                padding: 0px 20px;
                cursor: pointer;
            }
            .el-button{
                margin-top: 30px;
                // width: 100% !important;
            } 
        }
        .drawer_image{
            display: flex;
            justify-content: flex-start;
            div:nth-child(1){
                margin-right: 10px;
               
            }
            div:nth-child(2){
                font-size: 14px;
                color: #666666;
                height: 150px;
                padding-top: 60px;
                p{
                    line-height: 22px;
                }
                p:nth-child(1){
                    color: #ff2f4f;
                    
                    span{
                        font-size: 22px;
                    }
                }
            }
        }
    }


    .priceBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        margin-top: 20px;
        padding-left: 10px;
        span{
            font-size: 22px;
            font-weight: 700;
            color: #4095e5;
            /* margin-left: 10px; */
        }
        .el-button{
            border-radius: 0;
        }
    }
}


.checkoutQuick-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #f2f2f2;
}
.Item-left{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.Item-right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.Item-left .left-font{
  margin-left: 20px;
  font-size: 19px;
}
.Item-left .left-font p{
  margin-bottom: 10px;
}
.Item-left .left-font span{
  color: #ff2f4f;
  font-weight: 600;
}
.Item-right .el-input-number{
  width: 140px;
}

.companyImg{
    height: 600px;
}







@media screen and (max-width: 541px) {
    .company-info{
        width: 96%;
        padding-bottom: 50px;
    }
    .company-Main{
        width: 96%;
        padding: 10px 0px;
    }
    .companyImg{
        height: 260px;
    }
    .current{
        padding: 0 0;
    }
    .button-flex{
        position: absolute;
        bottom: 8px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #eff2f5;
        margin-top: 30px;
        margin-left: -6.5px;
    }
    .iconBox{
        width: 8%;
        display: flex;
        justify-content: space-between;
        padding: 0 5px 0 5px;
        margin-left: 2px;
        cursor: pointer;
        font-size: 30px;
    }
}
</style>